import { render, staticRenderFns } from "./LightboxProfile.vue?vue&type=template&id=585e233c&"
import script from "./LightboxProfile.vue?vue&type=script&lang=js&"
export * from "./LightboxProfile.vue?vue&type=script&lang=js&"
import style0 from "./LightboxProfile.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports